module.exports = __webpack_public_path__ + "static/media/catolica_school.ae92a2b2.jpg";